var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCounterTrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Combined Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Explorer-Desktop@1440px",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "05-Order-Detail_Filled",
    transform: "translate(-1251.000000, -653.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Detail",
    transform: "translate(496.000000, 258.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(456.000000, 344.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(286.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0208153,11 L26.4350288,12.4142136 L21.131,17.718 L22.8980807,19.4852814 L23.6066017,18.7781746 L25.0208153,20.1923882 L24.3122943,20.8994949 L26.4350288,23.0208153 L25.0208153,24.4350288 L22.8980807,22.3137085 L22.1923882,23.0208153 L20.7781746,21.6066017 L21.4838672,20.8994949 L19.716,19.132 L17.9504546,20.8987878 L18.6568542,21.6066017 L17.2426407,23.0208153 L16.536241,22.3130014 L14.4142136,24.4350288 L13,23.0208153 L15.1220275,20.8987878 L14.4142136,20.1923882 L15.8284271,18.7781746 L16.536241,19.4845743 L18.302,17.718 L13,12.4142136 L14.4142136,11 L19.717,16.303 L25.0208153,11 Z",
    id: "Combined-Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounterTrade);
export default __webpack_public_path__ + "static/media/CounterTrade.f69a552a3fc962e0a382611127fee3bd.svg";
export { ForwardRef as ReactComponent };